var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pagination-content"},[_c('el-pagination',{attrs:{"align":"center","currentPage":_vm.curPage,"page-size":_vm.pSize,"layout":_vm.layout,"total":_vm.pTotal,"page-sizes":_vm.pageSizes},on:{"current-change":_vm.handleCurrentChange,"size-change":_vm.handleSizeChange}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6332bc4a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/comm/components/Pagination.vue
// module id = null
// module chunks = 